import Bg1 from '../images/games/scoreboard/1.jpg';
import Bg2 from '../images/games/scoreboard/2.jpg';
import Bg3 from '../images/games/scoreboard/3.jpg';
import Bg4 from '../images/games/scoreboard/4.jpg';

import W from '../images/games/icons/W.png';
import U from '../images/games/icons/U.png';
import B from '../images/games/icons/B.png';
import R from '../images/games/icons/R.png';
import G from '../images/games/icons/G.png';
import C from '../images/games/icons/C.png';

export const BG_IMAGES = {
  1: Bg1,
  2: Bg2,
  3: Bg3,
  4: Bg4,
};

export const COLORS = {
  W,
  U,
  B,
  R,
  G,
  C,
};
